import Vue from 'vue'
import Vuex from 'vuex'

import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    screenWidth: 0,
    screenType: 0,
    menuIndex: 'home',
    isLogin: false,
    userData: {},
    album: {
      isCreated: false,
      isAll: false,
      page: 1,
      images: [],
    },
    blog: {
      isCreated: false,
      isAll: false,
      page: 1,
      blogList: [],
    }
  },
  getters,
  mutations,
  actions,
  strict: debug,
  modules: {
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js